import { ChangeEvent, Dispatch, SetStateAction, useCallback } from 'react'
import { filterBreadsByCategory, filterBreadsByCurrentTab, filterBreadsByStatus, filterBreadsByType } from 'lib/filter'
import { BreadType } from 'types/bread'
import { CategoryType } from 'types/category'
import { StockType, StockUnionType } from 'types/stock'
import { ScheduleType } from 'types/schedule'
import { DayOfWeekType } from 'lib/daysOfWeek'

type UseHandleKeywordParams = {
  breads: BreadType[]
  categories: CategoryType[]
  categoryName: string
  setBreadList: Dispatch<SetStateAction<BreadType[]>>
  setKeyword: Dispatch<SetStateAction<string>>
  isShownPrivate: boolean
  breadTypes?: StockUnionType[]
  stocks?: StockType[]
  schedules?: ScheduleType[]
  isFuture?: boolean
  checkedOrderTypes?: string[]
  dayOfWeek?: DayOfWeekType
  isTemporaryClose?: boolean
  currentTab?: 'released' | 'unreleased'
}

const useHandleKeyword = (params: UseHandleKeywordParams) => {
  const {
    breads,
    categories,
    categoryName,
    setBreadList,
    setKeyword,
    isShownPrivate,
    breadTypes,
    stocks,
    schedules,
    isFuture,
    checkedOrderTypes,
    dayOfWeek,
    isTemporaryClose,
    currentTab,
  } = params

  return useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value
      let _breads = breads
      // 空白であればカテゴリーのみのフィルタリング
      if (value === '') {
        _breads = filterBreadsByStatus(_breads, isShownPrivate)
        _breads = filterBreadsByCategory(categoryName, categories, _breads)
        if (breadTypes) {
          _breads = filterBreadsByType(_breads, breadTypes)
        }
        if (stocks && schedules && dayOfWeek && currentTab && checkedOrderTypes) {
          _breads = filterBreadsByCurrentTab({
            breads: _breads,
            checkedOrderTypes,
            currentTab,
            dayOfWeek,
            stocks,
            schedules,
          })
        }
        setBreadList([..._breads])
      }
      setKeyword(value)
    },
    [
      breads,
      categories,
      categoryName,
      setBreadList,
      setKeyword,
      isShownPrivate,
      stocks,
      schedules,
      isFuture,
      checkedOrderTypes,
      dayOfWeek,
      isTemporaryClose,
      breadTypes,
      currentTab,
    ]
  )
}

export default useHandleKeyword
